import React, { useState, useEffect } from "react";
import { HashRouter, Switch, Route, Redirect } from "react-router-dom";
import { createBrowserHistory } from "history";

import MainMenu from "./components/MainMenu/MainMenu";
import CarView from "./components/CarView/CarView";
import CarForm from "./components/CarForm/CarForm";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";

import CarFormConfirm from "./components/CarFormConfirm/CarFormConfirm";

import "./App.css";

function App() {
  const hashHistory = createBrowserHistory();
  hashHistory.listen(_ => {
    window.scrollTo(0, 0);
  });
  return (
    <div>
      <HashRouter history={hashHistory}>
        <ScrollToTop>
          <Switch>
            <Route exact path="/" component={MainMenu} />
            <Route exact path="/carview" component={CarView} />
            <Route exact path="/carform" component={CarForm} />
            <Route exact path="/carformconfirm" component={CarFormConfirm} />
          </Switch>
        </ScrollToTop>
      </HashRouter>
    </div>
  );
}

export default App;
